import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpEventType, HttpResponse, HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { finalize } from 'rxjs/operators';

import { MailCompose } from '../../model/mailbox/mail-compose';
import { FileUpload } from '@ascschool/share/file-upload/file-upload';
// import { FileUpload } from 'src/app/shared/file-upload/file-upload';

@Injectable({
    providedIn: 'root'
})
export class MailService { 

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json; charset=utf-8'
        })
    };
    version = 'v1.0/';
    constructor(private http: HttpClient) {
        this._isUploading = false;
        this._currentlyUploading = new BehaviorSubject(this._isUploading);
        this._uploadQueue = new BehaviorSubject([]);
        this._done = new BehaviorSubject(null);
        this._countInboxUnread = new BehaviorSubject(0);
        this._lstTag = new BehaviorSubject(null);
    }
    
    // Inbox

    private _countInboxUnread: BehaviorSubject<number>;
    private _lstTag: BehaviorSubject<any>;

    public get countInboxUnread() {
        return this._countInboxUnread.asObservable();
    }

    public refreshCountInboxUnread(count: number) {
        this._countInboxUnread.next(count);
    }

    public getListTag() {
        return this._lstTag.asObservable();
    }

    public refreshListTag(lstTag) {
        this._lstTag.next(lstTag);
    }

    private getMailFilterString(filter: any) {
        let arrParam = [];
        if (filter) {
            if (filter.SenderReceiver) {
                arrParam.push('SenderReceiver=' + filter.SenderReceiver);
            }
            if (filter.FromDate) {
                arrParam.push('FromDate=' + filter.FromDate.toISOString());
            }
            if (filter.ToDate) {
                arrParam.push('ToDate=' + filter.ToDate.toISOString());
            }
            if (filter.HasAttachment) {
                arrParam.push('HasAttachment=' + filter.HasAttachment);
            }
            if (filter.Tag) {
                arrParam.push('Tag=' + filter.Tag);
            }
            if(filter.PageIndex){
                arrParam.push('PageIndex=' + filter.PageIndex);
            }
            if(filter.PageSize){
                arrParam.push('PageSize=' + filter.PageSize);
            }
            if(filter.SearchTerm){
                arrParam.push('PageSize=' + filter.PageSize);
            }
            if(filter.SortName){
                arrParam.push('SortName=' + filter.SortName);
            }
            if(filter.SortDirection){
                arrParam.push('SortDirection=' + filter.SortDirection);
            }
        }

        return arrParam.join('&');

        // SenderReceiver: 1
        // FromDate: Fri Mar 20 2020 00:00:00 GMT 0800 (Singapore Standard Time)
        // ToDate: 
        // HasAttachment: 
        // Tag: 0
        // PageIndex: 1
        // PageSize: 20
        // SearchTerm: 
        // SortName: Time
        // SortDirection: DESC
    }

    getCountUnread() {
        return this.http.get(environment.apiUrl + this.version  + 'MailInbox/GetCountUnread', this.httpOptions);
    }

    getMyInbox(filter: any): Observable<any> {
        let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
        // 
        return this.http.get(environment.apiUrl + this.version  + 'MailInbox/Get?' + queryString, this.httpOptions);
    }

    getMailInboxById(id: number): Observable<any> {
        return this.http.get(environment.apiUrl + this.version  + `MailInbox/GetById/${id}`, this.httpOptions);
    }

    getMyInboxListSender(): Observable<any> {
        return this.http.get(environment.apiUrl + this.version  + 'MailInbox/GetListSender', this.httpOptions);
    }

    deleteMailInbox(id: number): Observable<any> {
        return this.http.delete(environment.apiUrl + this.version  + `MailInbox/DeleteById/${id}`, this.httpOptions);
    }

    moveMailInboxToTrash(lstId: number[]): Observable<any> {
        return this.http.post(environment.apiUrl + this.version  + 'MailInbox/MoveToTrash', lstId, this.httpOptions);
    }

    // Sent items

    getMyOutbox(filter: any): Observable<any> {
        let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
        // 
        return this.http.get(environment.apiUrl + this.version  + 'MailOutbox/Get?' + queryString, this.httpOptions);
    }

    getMailOutboxById(id: number): Observable<any> {
        return this.http.get(environment.apiUrl + this.version  + `MailOutbox/GetById/${id}`, this.httpOptions);
    }

    getMyOutboxListReceiver(): Observable<any> {
        return this.http.get(environment.apiUrl + this.version  + 'MailOutbox/GetListReceiver', this.httpOptions);
    }

    deleteMailOutbox(id: number): Observable<any> {
        return this.http.delete(environment.apiUrl + this.version  + `MailOutbox/DeleteById/${id}`, this.httpOptions);
    }

    moveMailOutboxToTrash(lstId: number[]): Observable<any> {
        return this.http.post(environment.apiUrl + this.version  + 'MailOutbox/MoveToTrash', lstId, this.httpOptions);
    }

    // Draft items

    getMyDraftItems(filter: any): Observable<any> {
        let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
        // 
        return this.http.get(environment.apiUrl + this.version  + 'MailOutbox/GetDraftItems?' + queryString, this.httpOptions);
    }

    // Deleted items

    getMyDeletedItems(filter: any): Observable<any> {
        let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
        
        return this.http.get(environment.apiUrl + this.version  + 'MailInbox/GetDeleted?' + queryString, this.httpOptions);
    }

    deleteMailOutboxMulti(lstId: number[]): Observable<any> {
        return this.http.post(environment.apiUrl + this.version  + 'MailInbox/ForceDelete/?source=Outbox', lstId, this.httpOptions);
    }

    deleteMailInboxMulti(lstId: number[]): Observable<any> {
        return this.http.post(environment.apiUrl + this.version  + 'MailInbox/ForceDelete?source=Inbox', lstId, this.httpOptions);
    }

    // Compose

    getComposeDetail(id: number): Observable<any> {
        return this.http.get(environment.apiUrl + this.version  + `MailOutbox/GetToCompose/?id=${id}`, this.httpOptions);
    }

    getListUser(): Observable<any> {
        return this.http.get(environment.apiUrl + this.version  + 'MailOutbox/GetListUser', this.httpOptions);
    }

    save(model: MailCompose): Observable<any> {
        return this.http.post(environment.apiUrl + this.version  + 'MailOutbox/Save', model, this.httpOptions);
    }

    send(model: MailCompose): Observable<any> {
        return this.http.post(environment.apiUrl + this.version  + 'MailOutbox/Send', model, this.httpOptions);
    }

    getListFiles(id: number): Observable<any> {
        return this.http.get(environment.apiUrl + this.version  + `MailAttachment/GetMailFiles/?id=${id}`, this.httpOptions);
    }

    deleteFile(id:any): Observable<any> {
        return this.http.delete(environment.apiUrl + this.version  + `MailAttachment/DeleteById/${id}`, this.httpOptions);
    }

    // Reply

    getReplyDetail(id: number, mode: 'reply' | 'reply-all' | 'forward'): Observable<any> {
        return this.http.get(environment.apiUrl + this.version  + `MailInbox/GetReply/?id=${id}&mode=${mode}`, this.httpOptions);
    }

    cloneFileToForward(id: number): Observable<any> {
        return this.http.get(environment.apiUrl + this.version  + `MailAttachment/CloneFilesByMailId/?id=${id}`, this.httpOptions);
    }
 
    // Tag

    getTagPaging(filter: any): Observable<any> {
        let queryString =  Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
        return this.http.get(environment.apiUrl + this.version  + 'MailTag/Get?' + queryString , this.httpOptions);
    }
    
    getMyTags() : Observable<any>{ 
        return this.http.get(environment.apiUrl + this.version  + 'MailTag/GetMyTag', this.httpOptions);
    }

    setTag(tagId: number, lstId: number[]) {
        return this.http.post(environment.apiUrl + this.version  + 'MailInbox/SetTagMulti/?tagId=' + tagId, lstId, this.httpOptions);
    }

    removeTag(lstId: number[]) {
        return this.http.post(environment.apiUrl + this.version  + 'MailInbox/RemoveTagMulti', lstId, this.httpOptions);
    }

    addTag(model): Observable<any> {
        return this.http.post(environment.apiUrl + this.version  + 'MailTag/Post', model, this.httpOptions);
    }

    editTag(model): Observable<any> {
        return this.http.put(environment.apiUrl + this.version  + 'MailTag/Put', model, this.httpOptions);
    }

    deleteTag(id: number): Observable<any> {
        return this.http.delete(environment.apiUrl + this.version  + `MailTag/DeleteById/${id}`, this.httpOptions);
    }

    // Download

    downloadFile(id: number): Observable<any> {
        return this.http.get(environment.apiUrl + this.version  + `MailAttachment/download/${id}`, {
            responseType: "arraybuffer", headers: new HttpHeaders({
                'Content-Type': 'application/json; charset=utf-8'
            })
        });
    }

    getDownloadUrl(id: number): Observable<any> {
        return this.http.get(environment.apiUrl + this.version  + 'MailAttachment/GetDownloadUrl/?id=' + id, this.httpOptions);
    }

    // Upload

    private _isUploading: boolean;
    private _currentlyUploading: BehaviorSubject<boolean>;
    private _files: FileUpload[] = [];
    private _uploadQueue: BehaviorSubject<FileUpload[]>;
    private _done: BehaviorSubject<any>;

    public  addFileToQueue(file: File) {
        const queuedUploadFile = new FileUpload(file);
        this._files.push(queuedUploadFile);

        this._uploadQueue.next(this._files);

        this.checkAndUploadNextFile();
    }

    public get done() {
        return this._done;
    }

    private checkAndUploadNextFile() {
        if (this._isUploading)
            return;

        let firstChoice = this._files.find(f => f.isWaitingForUpload);
        if (firstChoice)
            this.upload(firstChoice);
    }

    private upload(queuedUploadFile: FileUpload) {
        this.isUploading = true;
        queuedUploadFile.updateProgress(0);
        const request = this.createRequest(queuedUploadFile);
        this.http.request(request)
            .pipe(
                finalize(() => {
                    this.isUploading = false;
                    this.checkAndUploadNextFile();
                })
            )
            .subscribe(event => {
                if (event.type === HttpEventType.UploadProgress) {
                    const percentDone = Math.round(100 * event.loaded / event.total);
                    queuedUploadFile.updateProgress(percentDone);
                } else if (event instanceof HttpResponse) {
                    queuedUploadFile.completed();
                    this._done.next(event.body)
                }
                this._uploadQueue.next(this._files);
            }, (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {
                    // A client-side or network error occurred. Handle it accordingly.
                    queuedUploadFile.failed();
                } else {
                    // The backend returned an unsuccessful response code.
                    queuedUploadFile.failed();
                }

                this._uploadQueue.next(this._files);
            }, () => {

            });
    }

    private set isUploading(value: boolean) {
        this._isUploading = value;
        this._currentlyUploading.next(value);
    }

    createRequest(queuedUploadFile) {
        const formData = new FormData();
        formData.append('files', queuedUploadFile.file, queuedUploadFile.file.name);
        const request = new HttpRequest('POST', environment.apiUrl + this.version  + 'MailAttachment/upload', formData, {
            reportProgress: true
        });
        return request;
    }
}